import { render, staticRenderFns } from "./NewSpecial.vue?vue&type=template&id=49857bff&scoped=true&"
import script from "./NewSpecial.vue?vue&type=script&lang=js&"
export * from "./NewSpecial.vue?vue&type=script&lang=js&"
import style0 from "./NewSpecial.vue?vue&type=style&index=0&id=49857bff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49857bff",
  null
  
)

export default component.exports